export default __webpack_public_path__ + "static/media/Comp 2_00034.2394a962.png";